import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { ContactDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  contactId?: number;
};

type Return = {
  contactDetails: ContactDto | undefined;
  isErrorGettingContactDetails: boolean;
  isGettingContactDetails: boolean;
};

export const useGetContactDetails = (req: Req): Return => {
  const { contactsApi } = useApiClient();
  const { userId } = useUserContext();

  const { data, isError, isFetching } = useQuery<ContactDto | undefined, AxiosError>({
    enabled: Boolean(req.contactId),
    queryFn: async () => {
      if (!req.contactId) return undefined;
      const { data } = await contactsApi.getContact(userId, req.contactId);
      return data;
    },
    queryKey: [QueryKeyEnum.CONTACTS.DETAILS, req.contactId],
  });

  return {
    contactDetails: data,
    isErrorGettingContactDetails: isError,
    isGettingContactDetails: isFetching,
  };
};
